<template>
    <div>
        
        <div id="login">    
            <div class="tc w100 "><img src="@/assets/logo.jpg" ></div>  
            <br>      
            <form>
                <div class="form-group">
                    <p class="err">{{this.error}}</p>
                </div>
                <div class="form-group">
                    <label for="formGroupExampleInput">Email tài khoản <b class="clred">*</b></label>
                    <input @keyup="prelogin" type="text" class="form-control" autocomplete="true" v-model="account.name" id="formGroupExampleInput" placeholder="">
                </div>
                <div class="form-group">
                    <label for="formGroupExampleInput2">Mật khẩu <b class="clred">*</b></label>
                    <input @keyup="prelogin" type="password" class="form-control"  autocomplete="true" v-model="account.pass" id="formGroupExampleInput2" placeholder="">
                </div>
                <div class="form-group">
                    <button type="button" @click="login" class="btn btn-primary w100">Đăng nhập</button>                    
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name : 'login',
    data () {
        return {
            account:{
                name:'',
                pass:''
            },
            error:''
        }
    },
    methods: {
        prelogin(event){
            if(typeof event == 'object'){
                let keycode = event.keyCode || event.which
                if(keycode == 13){
                    if(this.account.name != '' && this.account.pass != ''){
                        this.login()
                    }
                }
            }
        },
        login(){
            console.log('start login')
            let data       = new FormData()
            data.append('username', this.account.name)
            data.append('password', this.account.pass)

            // call api
            axios.get(
                process.env.VUE_APP_LOGIN_URL,
                {
                    params:{
                        user : this.account.name,
                        pass : this.account.pass
                    }
                })
            .then((res) => {
                let response = res.data
                let code = response.code
                let error = response.error                
                if(code == 200){
                    this.error = error
                    this.$store.commit('setLogin', response)
                    location.reload()
                }else{
                    this.error = error
                }

            })
            .catch( (err) => {                
                console.log(err)
            })
            // end axiot
        }
    }
}
</script>
<style>
#login{
    width: 80%;
    max-width: 400px;
    padding: 30px;
    margin: 100px auto;
}
</style>
